import uuidV4 from 'uuid/v4';
import { Message } from '@wix/chat-sdk';
export var onAddUploadedImageItem = function (item, onSendMessage, chatroomId, summary, userId, deliveryMethods, badges) {
    var message = Message.fromImage({
        id: uuidV4(),
        userId: userId,
        chatroomId: chatroomId,
        transit: {
            status: 'uploaded',
        },
        summary: summary,
        uri: item.url,
        mediaFileId: '',
        mediaProvider: item.mediaProvider,
        fileName: item.fileName,
        fileSize: item.fileSize,
        width: item.width,
        height: item.height,
        deliveryMethods: deliveryMethods,
        badges: badges,
    });
    onSendMessage(message);
};
//# sourceMappingURL=onAddUploadedImageItem.js.map